module.exports = __webpack_public_path__ + "static/media/breadcrumb-18.46eb6653.svg";